import { useCallback, useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import type { Chat } from '@trinity/chat';
import { ChatSessionQueriesContext } from '@trinity/chat-components/components/Chat/context';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';

type Props = {
  chatInstanceId: number;
  queryIdentifier: string;
  onSuccess?: () => void;
};

export const useUpdateQueryFeedbackMutation = ({ chatInstanceId, queryIdentifier, onSuccess }: Props) => {

  const sessionQueries = useContext(ChatSessionQueriesContext);
  const dispatch = useContext(ChatStateDispatchContext);

  const dispatchRating = useCallback((rating: Chat.Rating) => {
    dispatch({
      type: 'query-rated',
      payload: {
        queryIdentifier,
        rating,
      },
    });
  }, [dispatch, queryIdentifier]);

  const apiClient = useChatApiClient();

  return useMutation({
    mutationKey: ['query:patch:feedback'], mutationFn: (feedback: Chat.QueryFeedback) => {
      return apiClient.queries.updateQueryFeedback({
        chatInstanceId,
        queryIdentifier,
        feedback,
      });
    }, onMutate: feedback => {
      const query = sessionQueries[queryIdentifier];
      dispatchRating(feedback.rating);
      return { oldRating: query.rating };
    }, onError: (res, variables, context) => {
      dispatchRating(context.oldRating);
    }, onSuccess: res => {
      dispatchRating(res.query.rating);
      onSuccess();
    },
  });
};